export default __webpack_public_path__ + "static/media/guide_test.c405836d.png";